import {ReplayHighlightData} from '../../core/UIGameReplayControls/ReplayControlsContent/ReplaySlider'
import {PlayerColor} from '@colonist/game-states'
import {StateCreator} from 'zustand'

interface ReplayControls {
    onPreviousTurn: VoidFunction
    onPreviousAction: VoidFunction
    onNextAction: VoidFunction
    onNextTurn: VoidFunction
    onChangePerspective: (color: PlayerColor) => void
    currentPlayerPerspective: PlayerColor
    onShare: VoidFunction
    numberOfActions: number
    highlightData: ReplayHighlightData[]
    onChangeActionIndex: (actionIndex: number) => void
    onClickLog: (logIndex: number) => void
}

export interface GameReplaySliceProps {
    isReplay: boolean
}

export interface GameReplaySlice {
    gameReplay: {
        isReplay: boolean
        setIsReplay: (isReplay: boolean) => void
        actionIndex: number
        setActionIndex: (actionIndex: number) => void
        focusedLogIndex: number | null
        setFocusedLogIndex: (logIndex: number | null) => void
        replayControls?: ReplayControls
        setReplayControls: (controls: ReplayControls) => void
    }
}

export const createGameReplaySlice = (gameReplay: GameReplaySliceProps): StateCreator<GameReplaySlice> => (set, get) => ({
    gameReplay: {
        isReplay: gameReplay.isReplay,
        setIsReplay: (isReplay: boolean) => {
            set({
                gameReplay: {
                    ...get().gameReplay,
                    isReplay: isReplay,
                },
            })
        },
        actionIndex: -1,
        setActionIndex: (actionIndex: number) => {
            set({
                gameReplay: {
                    ...get().gameReplay,
                    actionIndex: actionIndex,
                },
            })
        },
        focusedLogIndex: null,
        setFocusedLogIndex: (logIndex: number | null) => {
            set({
                gameReplay: {
                    ...get().gameReplay,
                    focusedLogIndex: logIndex,
                },
            })
        },
        setReplayControls: (controls: ReplayControls) => {
            set({
                gameReplay: {
                    ...get().gameReplay,
                    replayControls: controls,
                },
            })
        },
    },
})
